// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2KAjx","list":"BalanceDue_list__1WWtJ","listRow":"BalanceDue_listRow__20eqS","total":"BalanceDue_total__loJM9"};